module.exports = __webpack_public_path__ + "static/media/series_reports.3b05d348.svg";